import { render, staticRenderFns } from "./DeleteAccountCancelRequest.vue?vue&type=template&id=e39a4f8c&lang=pug"
import script from "./DeleteAccountCancelRequest.vue?vue&type=script&lang=js"
export * from "./DeleteAccountCancelRequest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports